import { mapGetters } from 'vuex';

export default {
    name: 'brokerageBanner',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb', 'getSplit'])
    },
    methods: {
        showSignup(){
            this.$eventBus.$emit('dialog-center', {name: 'mvtAuthenticate', opt: {type: 'mvtLogin'}, trigger: this.$options.name});
        }
    }
};